'use client';

import React from 'react';

import { t } from '../../../../i18n';
import Icon from '../../../../components/Icon';
import { useReportComments } from '../ReportCommentsProvider';

import s from './CommentCountButton.module.scss';

// Counts every comment on the report, so it matches the panel's list.
const CommentCountButton = () => {
    const { comments, isPanelOpen, togglePanel } = useReportComments();

    if (!comments?.length) return null;

    return (
        <button
            type="button"
            className={s.Root}
            aria-label={t('reportComments.countLabel', {
                count: comments.length,
            })}
            aria-expanded={isPanelOpen}
            onClick={togglePanel}>
            <Icon name="Comment" className={s.Icon} aria-hidden />
            {comments.length}
        </button>
    );
};

export default CommentCountButton;
